var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.243 2.665a1.5 1.5 0 0 1 2.076-.437l9.997 6.515a1.5 1.5 0 0 1 0 2.514L6.32 17.774A1.5 1.5 0 0 1 4 16.517V3.484c0-.29.085-.575.243-.819"
})));
export default SvgIconPlay;